import { render } from "./TaxOfficeListField.vue?vue&type=template&id=487752d9&scoped=true&ts=true"
import script from "./TaxOfficeListField.vue?vue&type=script&lang=ts"
export * from "./TaxOfficeListField.vue?vue&type=script&lang=ts"

import "./TaxOfficeListField.vue?vue&type=style&index=0&id=487752d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487752d9"]])

export default __exports__